var map = {
	"./bag-dynamic-gradient.png": 3191,
	"./calender-dynamic-gradient.png": 1724,
	"./chart-dynamic-gradient.png": 709,
	"./clock-dynamic-gradient.png": 7533,
	"./dollar-dynamic-gradient.png": 9445,
	"./explorer-dynamic-gradient.png": 2815,
	"./gift-dynamic-gradient.png": 1930,
	"./mail-dynamic-gradient.png": 3739,
	"./money-bag-dynamic-gradient.png": 6992,
	"./setting-dynamic-gradient.png": 3014,
	"./wallet-dynamic-gradient.png": 7967,
	"./zoom-dynamic-gradient.png": 7210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;